import React, { FC, ReactElement } from 'react';
import { useAuthentication } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import LoadingIconOnly from '../ui-component/loading/LoadingIconOnly';

interface RouteProps {
	element: ReactElement;
}

export const AuthenticationRoute: FC<RouteProps> = ({ element }) => {
	const { loading, isAuthenticated } = useAuthentication();

	if (loading) {
		return <LoadingIconOnly />;
	}
	return isAuthenticated ? <Navigate to="/mein-bereich" /> : element;
};
export const PrivateRoute: FC<RouteProps> = ({ element }) => {
	const { loading, isAuthenticated } = useAuthentication();

	if (loading) {
		return <LoadingIconOnly />;
	}
	if (!isAuthenticated) {
		return <Navigate to="/login" />;
	}
	return element;
};
